<template>
  <div class="home-container">
    <div class="box has-background-white-ter no-border-print shared-error" v-if="shareNotFound">
      <DoodleMessage :message="doodleForm.errorMessage" message-class="has-text-danger"
        v-show="doodleForm.errorMessage" />
    </div>
    <div class="box main-box no-border-print">
      <div class="has-text-right toggle-section">
        <div class="dropdown is-marginless is-paddingless is-right" v-bind:class="{ 'is-active': showSettingsMenu }"
          v-click-outside="hideSettingsMenu">
          <div class="dropdown-trigger is-marginless is-paddingless">
            <a @click="showSettingsMenuMtd">
              <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="copy">
                <path
                  d="M0 1.5C0 0.67157 0.67157 0 1.5 0H4.26393C5.2217 0 6.02473 0.55996 6.57541 1.18398C6.98525 1.64839 7.47871 2 8 2H12.5007C13.3296 2 14 2.67203 14 3.5V10.5C14 11.3284 13.3284 12 12.5 12H1.5C0.67157 12 0 11.3284 0 10.5V1.5ZM1.5 1C1.22386 1 1 1.22386 1 1.5V4H13V3.5C13 3.22341 12.7764 3 12.5007 3H8C7.03611 3 6.28947 2.37127 5.82562 1.84565C5.37381 1.33367 4.82125 1 4.26393 1H1.5ZM13 5H1V10.5C1 10.7761 1.22386 11 1.5 11H12.5C12.7761 11 13 10.7761 13 10.5V5Z"
                  fill="#5FC4B8" />
              </svg>
            </a>
          </div>
          <div class="dropdown-menu" id="dropdown-menu1" role="menu">
            <div class="dropdown-content has-text-weight-semibold">
              <div class="dropdown-item files-title">
                <div class="has-text-white has-text-left">Files</div>
              </div>
              <div class="dropdown-item files-menu">
                <label class="has-text-white" id="upload-button" v-if="!uploadInProgress">
                  <span class="upload-file">Upload File</span>
                  <input class="file-input upload-pointer" type="file" name="file" @change="tryUploadFile($event)"
                    title="">
                </label>
              </div>
              <div class="dropdown-item has-text-left has-text-white file-list-dropdown is-paddingless">
                <div v-for="file in inputFiles" v-bind:key="fileEditor" class="files-list">
                  <span>/uploads/{{ file }}</span>
                  <a class="hast-text-white" @click.prevent="removeFile(file)"><svg width="14" height="16"
                      viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.5 1H8.5C8.77614 1 9 1.22386 9 1.5V2.5H5V1.5C5 1.22386 5.22386 1 5.5 1ZM10 2.5V1.5C10 0.671573 9.32843 0 8.5 0H5.5C4.67157 0 4 0.671573 4 1.5V2.5H1.50566C1.50226 2.49997 1.49885 2.49997 1.49544 2.5H0.5C0.223858 2.5 0 2.72386 0 3C0 3.27614 0.223858 3.5 0.5 3.5H1.0384L1.89116 14.1595C1.97431 15.1989 2.84207 16 3.88479 16H10.1152C11.1579 16 12.0257 15.1989 12.1088 14.1595L12.9616 3.5H13.5C13.7761 3.5 14 3.27614 14 3C14 2.72386 13.7761 2.5 13.5 2.5H12.5046C12.5011 2.49997 12.4977 2.49997 12.4943 2.5H10ZM11.9584 3.5L11.112 14.0797C11.0704 14.5994 10.6366 15 10.1152 15H3.88479C3.36343 15 2.92955 14.5994 2.88798 14.0797L2.0416 3.5H11.9584ZM4.47064 4.50086C4.74631 4.48465 4.98292 4.69497 4.99914 4.97064L5.49914 13.4706C5.51535 13.7463 5.30503 13.9829 5.02936 13.9991C4.7537 14.0154 4.51708 13.805 4.50086 13.5294L4.00086 5.02936C3.98465 4.7537 4.19497 4.51708 4.47064 4.50086ZM9.52936 4.50086C9.80503 4.51708 10.0154 4.7537 9.99914 5.02936L9.49914 13.5294C9.48292 13.805 9.2463 14.0154 8.97064 13.9991C8.69497 13.9829 8.48465 13.7463 8.50086 13.4706L9.00086 4.97064C9.01708 4.69497 9.2537 4.48465 9.52936 4.50086ZM7 4.5C7.27614 4.5 7.5 4.72386 7.5 5V13.5C7.5 13.7761 7.27614 14 7 14C6.72386 14 6.5 13.7761 6.5 13.5V5C6.5 4.72386 6.72386 4.5 7 4.5Z"
                        fill="white" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown is-marginless is-paddingless is-right" v-bind:class="{ 'is-active': showFilesMenu }"
          v-click-outside="hideFilesMenu">
          <div class="is-marginless is-paddingless">
            &nbsp;&nbsp;<a @click="showFilesMenuMtd">
              <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="more">
                <path
                  d="M3.5 12C3.5 12.8284 2.82843 13.5 2 13.5C1.17157 13.5 0.5 12.8284 0.5 12C0.5 11.1716 1.17157 10.5 2 10.5C2.82843 10.5 3.5 11.1716 3.5 12ZM3.5 7C3.5 7.82843 2.82843 8.5 2 8.5C1.17157 8.5 0.5 7.82843 0.5 7C0.5 6.17157 1.17157 5.5 2 5.5C2.82843 5.5 3.5 6.17157 3.5 7ZM3.5 2C3.5 2.82843 2.82843 3.5 2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2Z"
                  fill="#5FC4B8" />
              </svg>
              &nbsp;&nbsp;
            </a>
          </div>
          <div class="dropdown-menu" id="dropdown-menu3" role="menu">
            <div class="dropdown-content has-text-weight-semibold">
              <div class="dropdown-item">
                <div class="font-size has-text-white has-text-left">Font Size</div>
                <div class="field has-addons font-input">
                  <div class="control">
                    <button class="button" @click="decreaseFont" :disabled="fontSize <= 12">
                      -
                    </button>
                  </div>
                  <div class="control">
                    <input class="input has-text-centered" type="text" v-model="fontSize">
                  </div>
                  <div class="control">
                    <button class="button" @click="increaseFont" :disabled="fontSize >= 70">
                      +
                    </button>
                  </div>
                </div>
              </div>
              <div class="dropdown-divider" />
              <a class="dropdown-item files-list" @click="exportFile">
                <span class="icon-align">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.5 9.8999C0.632608 9.8999 0.759785 9.95258 0.853553 10.0463C0.947322 10.1401 1 10.2673 1 10.3999V12.8999C1 13.1651 1.10536 13.4195 1.29289 13.607C1.48043 13.7945 1.73478 13.8999 2 13.8999H14C14.2652 13.8999 14.5196 13.7945 14.7071 13.607C14.8946 13.4195 15 13.1651 15 12.8999V10.3999C15 10.2673 15.0527 10.1401 15.1464 10.0463C15.2402 9.95258 15.3674 9.8999 15.5 9.8999C15.6326 9.8999 15.7598 9.95258 15.8536 10.0463C15.9473 10.1401 16 10.2673 16 10.3999V12.8999C16 13.4303 15.7893 13.939 15.4142 14.3141C15.0391 14.6892 14.5304 14.8999 14 14.8999H2C1.46957 14.8999 0.960859 14.6892 0.585786 14.3141C0.210714 13.939 0 13.4303 0 12.8999V10.3999C0 10.2673 0.0526784 10.1401 0.146447 10.0463C0.240215 9.95258 0.367392 9.8999 0.5 9.8999Z"
                      fill="#5FC4B8" />
                    <path
                      d="M7.64566 11.854C7.6921 11.9006 7.74728 11.9375 7.80802 11.9627C7.86877 11.9879 7.93389 12.0009 7.99966 12.0009C8.06542 12.0009 8.13054 11.9879 8.19129 11.9627C8.25203 11.9375 8.30721 11.9006 8.35366 11.854L11.3537 8.854C11.4475 8.76011 11.5003 8.63278 11.5003 8.5C11.5003 8.36722 11.4475 8.23989 11.3537 8.146C11.2598 8.05211 11.1324 7.99937 10.9997 7.99937C10.8669 7.99937 10.7395 8.05211 10.6457 8.146L8.49966 10.293V1.5C8.49966 1.36739 8.44698 1.24021 8.35321 1.14645C8.25944 1.05268 8.13226 1 7.99966 1C7.86705 1 7.73987 1.05268 7.6461 1.14645C7.55233 1.24021 7.49966 1.36739 7.49966 1.5V10.293L5.35366 8.146C5.25977 8.05211 5.13243 7.99937 4.99966 7.99937C4.86688 7.99937 4.73954 8.05211 4.64566 8.146C4.55177 8.23989 4.49902 8.36722 4.49902 8.5C4.49902 8.63278 4.55177 8.76011 4.64566 8.854L7.64566 11.854Z"
                      fill="#5FC4B8" />
                  </svg>
                  &nbsp;&nbsp;
                </span>
                <span>Export</span>
              </a>
              <div class="dropdown-divider" />
              <a class="dropdown-item has-text-weight-semibold files-list" @click="showResetConfirm">
                <span class="icon-align"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.99996 3C6.91931 3.00042 5.86789 3.35093 5.00316 3.99904C4.13844 4.64715 3.50697 5.55797 3.20332 6.59508C2.89968 7.63219 2.94021 8.73976 3.31884 9.7519C3.69748 10.764 4.39384 11.6263 5.30362 12.2094C6.2134 12.7926 7.28763 13.0653 8.36542 12.9868C9.4432 12.9082 10.4665 12.4826 11.2821 11.7736C12.0977 11.0647 12.6616 10.1105 12.8895 9.0542C13.1173 7.99784 12.9968 6.89611 12.546 5.914C12.4969 5.7946 12.4959 5.66084 12.5432 5.54072C12.5905 5.42061 12.6824 5.32344 12.7998 5.26957C12.9171 5.21569 13.0507 5.20927 13.1726 5.25167C13.2945 5.29406 13.3954 5.38197 13.454 5.497C13.9949 6.67559 14.1395 7.99773 13.866 9.26538C13.5925 10.533 12.9157 11.678 11.9369 12.5286C10.9581 13.3793 9.73 13.89 8.4366 13.9842C7.1432 14.0783 5.85411 13.7509 4.76243 13.0509C3.67074 12.3509 2.83522 11.3161 2.38102 10.1014C1.92682 8.88676 1.87839 7.55762 2.24299 6.31311C2.60759 5.0686 3.36559 3.97571 4.40344 3.19815C5.44129 2.42059 6.70314 2.00022 7.99996 2V3Z"
                      fill="#5FC4B8" />
                    <path
                      d="M8 4.46609V0.534086C8.00002 0.486583 8.01357 0.440067 8.03907 0.399987C8.06457 0.359907 8.10096 0.327921 8.14398 0.307775C8.187 0.287629 8.23487 0.280157 8.28198 0.286234C8.32909 0.29231 8.3735 0.311684 8.41 0.342086L10.77 2.30809C10.89 2.40809 10.89 2.59209 10.77 2.69209L8.41 4.65809C8.3735 4.68849 8.32909 4.70786 8.28198 4.71394C8.23487 4.72002 8.187 4.71254 8.14398 4.6924C8.10096 4.67225 8.06457 4.64027 8.03907 4.60019C8.01357 4.56011 8.00002 4.51359 8 4.46609Z"
                      fill="#5FC4B8" />
                  </svg>&nbsp;&nbsp;</span>
                <span>Reset</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="code" class="code-editor no-border-print"
        v-bind:style="{ 'min-height': ((this.codeEditorOnly) ? '90vh' : '60vh') }"></div>
      <div v-if="!codeEditorOnly">
        <div class="columns execute-section is-mobile">
          <div class="column is-8-desktop is-7-mobile">
            <button class="button execute-button" @click="tryExecute" :disabled="runDisabled">
              <span v-show="!isCodeExecuting">Run</span>
              <span v-if="isCodeExecuting">
                <font-awesome-icon icon="spinner" class="fa-spin" /></span>
            </button>&nbsp;
            <button class="button stop-button is-mobile-small" @click="stopExecution" v-if="isCodeExecuting">
              <span>Stop</span>
            </button>
          </div>
          <div class="control column is-4-desktop is-5-mobile has-text-right">
            <input v-model="args" class="input args" type="text" name="arguments" autocomplete="off"
              placeholder="Enter command line arguments" />
          </div>
        </div>
      </div>
      <div class="id-box" v-if="!codeEditorOnly">
        <div class="output-message">{{ outputMessage }}</div>
        <div id="output" class="code-editor no-border-print">
        </div>
        <a class="clear-link" @click="clearOutput">clear</a>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': showConfirmationBox }" v-click-outside="hideResetConfirm">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="columns">
          <div class="column is-11">
            <div class="confim-title">Are you sure you want to reset the coding editor?</div>
            <div class="confirm-body">Resetting the editor will delete your work and return the editor to its initial
              state. If you would like to save your code before resetting, please continue editing or close this window
              to export. </div>
          </div>
          <div class="column is-1">
            <a @click="hideResetConfirm"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.293723 0.293723C0.386594 0.200617 0.496921 0.126747 0.618385 0.076345C0.739849 0.0259431 0.870063 0 1.00157 0C1.13307 0 1.26329 0.0259431 1.38475 0.076345C1.50622 0.126747 1.61654 0.200617 1.70941 0.293723L7.00026 5.58657L12.2911 0.293723C12.3841 0.200767 12.4944 0.127031 12.6159 0.0767236C12.7373 0.0264163 12.8675 0.000523453 12.999 0.000523453C13.1304 0.000523453 13.2606 0.0264163 13.382 0.0767236C13.5035 0.127031 13.6138 0.200767 13.7068 0.293723C13.7998 0.386679 13.8735 0.497033 13.9238 0.618485C13.9741 0.739938 14 0.87011 14 1.00157C14 1.13303 13.9741 1.2632 13.9238 1.38465C13.8735 1.50611 13.7998 1.61646 13.7068 1.70941L8.41395 7.00026L13.7068 12.2911C13.7998 12.3841 13.8735 12.4944 13.9238 12.6159C13.9741 12.7373 14 12.8675 14 12.999C14 13.1304 13.9741 13.2606 13.9238 13.382C13.8735 13.5035 13.7998 13.6138 13.7068 13.7068C13.6138 13.7998 13.5035 13.8735 13.382 13.9238C13.2606 13.9741 13.1304 14 12.999 14C12.8675 14 12.7373 13.9741 12.6159 13.9238C12.4944 13.8735 12.3841 13.7998 12.2911 13.7068L7.00026 8.41395L1.70941 13.7068C1.61646 13.7998 1.50611 13.8735 1.38465 13.9238C1.2632 13.9741 1.13303 14 1.00157 14C0.87011 14 0.739938 13.9741 0.618485 13.9238C0.497033 13.8735 0.386679 13.7998 0.293723 13.7068C0.200767 13.6138 0.127031 13.5035 0.0767236 13.382C0.0264163 13.2606 0.000523453 13.1304 0.000523453 12.999C0.000523453 12.8675 0.0264163 12.7373 0.0767236 12.6159C0.127031 12.4944 0.200767 12.3841 0.293723 12.2911L5.58657 7.00026L0.293723 1.70941C0.200617 1.61654 0.126747 1.50622 0.076345 1.38475C0.0259431 1.26329 0 1.13307 0 1.00157C0 0.870063 0.0259431 0.739849 0.076345 0.618385C0.126747 0.496921 0.200617 0.386594 0.293723 0.293723Z"
                  fill="white" />
              </svg>
            </a>
          </div>
        </div>
        <div class="confirm-buttons">
          <button class="button execute-button" @click="hideResetConfirm">
            keep editing
          </button>&nbsp;
          <button class="button stop-button" @click="reset">
            reset editor
          </button>
        </div>
        <div id="ideContainer" class="g-recaptcha is-hidden-print margin-top-20px has-text-centered is-hidden"
          data-size="invisible" data-sitekey="6LfPlOsUAAAAAIALEFUM1022nNwsyWjpATeuYMdi" data-badge="inline"></div>
      </div>
    </div>
  </div>
</template>

<script>
import aceMixin from './../assets/javascript/ide-mixin'
import { IDE_CONST, ROBOT_CONST } from '../assets/javascript/constants'
import DoodleMessage from '../components/Utils/DoodleMessage'
import formMixin from './../assets/javascript/form-mixin'
import { META } from '../assets/javascript/meta'
import loadScriptInBody from '../assets/javascript/loadScriptInBody'
import { ACE_UTIL } from '@/assets/javascript/ace-util'
import { saveAs } from 'file-saver'
import recaptchaMixin from '../assets/javascript/recaptcha-mixin'
import jqueryFileUpload from 'jquery-simple-upload'

export default {
  name: 'embedIText',
  components: { DoodleMessage },
  mixins: [aceMixin, formMixin, recaptchaMixin],
  mounted() {
    if (this.$store.state.robotChecked === false) {
      this.loadRecaptcha('ideContainer', this.doRoboCheck)
    }

    this.isEmbed = true
    this.interactiveMode = true

    this.initSession()

    this.ideMeta = META['java']
    window._.delay(this.initEditors, 500, 1)
    let postAceAction = (count) => {
      if (window.ace) {
        this.pymChild = new window.pym.Child()

        this.pymChild.onMessage('jdenablepaste', () => {
          this.codeEditor.commands.addCommand({
            name: 'paste',
            bindKey: { win: 'Ctrl-V', mac: 'Cmd-V' }
          })
        })
        this.pymChild.onMessage('jddisablepaste', () => {
          this.codeEditor.commands.commands['paste'].exec = function () {
            window.alert('Our admins have disabled pasting into this code editor.')
          }
        })
        this.pymChild.onMessage('jdreadonly', () => { this.codeEditor.setReadOnly(true) })
        this.pymChild.onMessage('jdreadwrite', () => { this.codeEditor.setReadOnly(false) })
        this.pymChild.onMessage('jdclearide', () => { this.codeEditor.getSession().setValue(' ') })
        this.pymChild.onMessage('jdrevertide', () => { this.codeEditor.getSession().setValue(this.project.script) })

        this.pymChild.onMessage('setScript', (data) => {
          data = JSON.parse(data)
          if (data.id === this.$route.query.id) {
            this.theme = data.theme
            this.codeEditorOnly = data.codeEditorOnly
            this.resetToStarterCode = data.resetToStarterCode
            this.initScripts(data)
          }
        })
        this.pymChild.onMessage('jdupdateide', (data) => {
          data = JSON.parse(data)
          if (data.script) {
            this.codeEditor.getSession().setValue(data.script)
          }
        })

        this.javaLibraries = this.javaLibs
        this.pymChild.sendMessage('getScript', JSON.stringify({ id: this.$route.query.id }))
      } else if (count < 20) {
        window._.delay(postAceAction, 600, count + 1)
      }
    }
    let postAction = (count) => {
      if (window.pym) {
        // window.pym.Child({ polling: 500 })
        window._.delay(postAceAction, 100, 1)
      } else if (count < 20) {
        window._.delay(postAction, 600, count + 1)
      }
    }

    window._.delay(postAction, 600, 1)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      loadScriptInBody.loadScriptInBody('/assets/javascript/ace.min.js')
        .then(() => {
          loadScriptInBody.loadScriptInBody('/assets/javascript/ext-language_tools.js')
          loadScriptInBody.loadScriptInBody('/assets/javascript/ext-static_highlight.js')
        })
      loadScriptInBody.loadScriptInBody('/assets/jdoodle-pym-original.min.js')
    })
    next()
  },
  computed: {
    language() {
      return this.ideMeta.language
    },
    aceLanguageCode() {
      return this.ideMeta.aceCode ? this.ideMeta.aceCode : this.ideMeta.language
    }
  },
  methods: {
    initSession: function () {
      let url = '/api/doodle/initOutlier'
      let data = {}
      $.ajax({
        type: 'POST',
        url: url,
        data: data
      }).done((data) => {
        this.inputFiles = data.inputFiles
        if (data.robotChecked === true) {
          this.$store.commit('robotCheckDone')
        }
        $.ajaxSetup({
          headers: { 'Kurukku-Kuri': data.kurukkuKuri }
        })
      }).fail((jqXHR, textStatus, errorThrown) => {
        // error handling
      })
    },
    getUrl(file) {
      return `/api/projectSync/downloadItem?projectKey=1001&name=${encodeURI(file)}&type=output`
    },
    ideExecute() {
      this.execute()
    },
    postExecuteSuccessHandling() {

    },
    showSettingsMenuMtd() {
      this.showSettingsMenu = !this.showSettingsMenu
    },
    hideSettingsMenu() {
      this.showSettingsMenu = false
    },
    showFilesMenuMtd() {
      this.showFilesMenu = !this.showFilesMenu
    },
    hideFilesMenu() {
      this.showFilesMenu = false
    },
    initScripts(data) {
      this.project = data

      if (this.project.libs) {
        this.project.libs = this.project.libs.split(',')
      }

      this.onLanguageChange()
      if (!this.project.script || this.project.script < 1) {
        this.runDisabled = true
      }
    },
    onLanguageChange() {
      this.outputFiles = []
      this.showOutput = false
      this.ideMeta = META[this.project.language]
      if (this.project.versionIndex) {
        this.versionIndex = parseInt(this.project.versionIndex)
      }
      window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().setValue(this.project.script)
      ACE_UTIL.changeLanguage(this.codeEditor, this.aceLanguageCode, this.theme)
    },
    decreaseFont() {
      if (this.fontSize > 12) {
        this.fontSize--
        this.setFontSize()
      }
    },
    increaseFont() {
      if (this.fontSize < 71) {
        this.fontSize++
        this.setFontSize()
      }
    },
    setFontSize() {
      window.ace.edit(IDE_CONST.CODE_EDITOR).setFontSize(this.fontSize)
      window.ace.edit(IDE_CONST.OUTPUT_EDITOR).setFontSize(this.fontSize)
    },
    exportFile() {
      this.showSettingsMenu = false
      let code = window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().getValue()
      let fileName = 'jdoodle.' + this.ideMeta.fileName
      if (this.language === 'java') {
        // eslint-disable-next-line no-useless-escape
        let regex = /(public)([\s]*)(class)([\s]*)([\w\$]*)([\s]*)({)/
        let match = regex.exec(code)
        if (match && match.length >= 5) {
          fileName = match[5] + '.java'
        } else {
          fileName = 'jdoodle.java'
        }
      }

      let file = new File([code], fileName, { type: 'text/plain;charset=utf-8' })
      saveAs(file)
    },
    tryUploadFile(event) {
      this.uploadEvent = event
      this.callViaCaptcha(this.uploadFile, () => { this.doodleForm.errorMessage = ROBOT_CONST.ROBOT_ERROR })
    },
    uploadFile() {
      if (this.inputFiles.length >= this.maxUploads) {
        this.uploadMessage = 'Maximum upload limit reached.'
        _.delay(() => { this.uploadMessage = null }, 5000)
        return
      }

      if (this.uploadEvent.target.files[0].size >= this.maxFileSize) {
        this.uploadMessage = 'File exceeds the acceptable size.'
        _.delay(() => { this.uploadMessage = null }, 5000)
        return
      }

      let vm = this
      $(this.uploadEvent.target).simpleUpload('/api/projectSync/uploadInputFile', {
        data: { projectKey: 1001 },

        start: function (file) {
          vm.currentUpload = this.upload
          vm.uploadInProgress = true
        },

        progress: (progress) => {
        },

        success: (data) => {
          this.inputFiles = data.inputFiles
          this.uploadMessage = 'Upload successful'
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        },

        cancel: () => {
          this.uploadMessage = 'Upload Canceled'
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        },

        error: (error) => {
          if (error.xhr.status === 403) {
            this.clearRobotCheckStatus()
          }
          this.uploadMessage = error.message
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        }

      })
    },
    clearOutput() {
      window.ace.edit(IDE_CONST.OUTPUT_EDITOR).getSession().setValue('')
      this.outputMessage = ''
    },
    removeFile(file) {
      let url = '/api/projectSync/deleteInputFile'
      let data = { projectKey: 1001, name: file }
      $.ajax({
        type: 'POST',
        url: url,
        data: data
      }).done((data) => {
        this.inputFiles.splice(this.inputFiles.indexOf(file), 1)
      }).fail((jqXHR, textStatus, errorThrown) => {
        // error handling
      })
    },
    getInputUrl(file) {
      return `/api/projectSync/downloadItem?projectKey=1001&name=/${encodeURI(file)}&type=input`
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../node_modules/bulma-switch/dist/css/bulma-switch.min.css";
@import "./../assets/style/ide";

.home-container {
  background: #F2F2F2;
}

.main-box {
  padding: 5px 60px 29px;
  background: #161618;
  border-radius: 0;
}

.execute-button {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;

  color: #161618;
  background: #5FC4B8;
  border: none;

  padding: 10.5px 24px;
  width: 81px;
  height: 38px;
}

.stop-button {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;

  /* 5FC4B8 - Teal Regular */

  color: #5FC4B8;
  background: #25272B;

  border: 1px solid #5FC4B8;

  padding: 10.5px 24px;
  width: 81px;
  height: 38px;
}

.copy {
  margin-right: 1em;
}

.ide-title,
.switch[type=checkbox]+label.ide-title {
  font-size: 0.9em;
  margin-top: 1em;
}

.column {
  padding-top: 0.15em;
  padding-bottom: 0.10em;
}

.execute-section {
  margin-top: 1em;
  margin-bottom: 1em;
}

.interactive-mode-top {
  margin-top: 0.75em;
}

.embed-brand-area {
  margin-top: 2em;
  margin-bottom: 2em;
}

.info-text {
  font-size: 0.85em;
  color: black;
  font-weight: 500;
}

.powered-by {
  vertical-align: bottom;
}

#code {
  border: 1px solid #494D52;
  border-radius: 5px;
}

.toggle-section {
  background: #161618;
  padding: 5px;
}

.clipboard {
  width: 15px;
  height: 15px;
}

.clipboard-link {
  padding: 5px;
  background: #F99D25;
  margin-left: 10px;
}

.upload-pointer {
  cursor: pointer;
}

.upload-message {
  color: #F99D25;
}

.count-tag {
  color: #F99D25;
  font-weight: bold;
  border-radius: 20px;
}

#files-menu {
  position: absolute;
  right: 120px;
  bottom: 35px;
  vertical-align: top;
  z-index: 38;
}

.folder-note {
  word-break: break-all;
}

#code .ace_gutter {
  background: black;
}

#code .ace-terminal-theme .ace_gutter .ace_layer div.ace_gutter-cell {
  color: white !important;
}

.args {
  background: rgba(0, 0, 0);
  border: 1px solid #494D52;
  box-sizing: border-box;
  border-radius: 5px;
  color: white;
}

.args::placeholder {
  color: rgba(255, 255, 255, 0.3);
  opacity: 1;
}

.dropdown-content {
  background: #25272B;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.font-input .button,
.font-input input {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
}

.dropdown-divider {
  background-color: rgba(255, 255, 255, 0.1);
}

.dropdown-item {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;

  letter-spacing: 1px;
  text-transform: uppercase;
  font-feature-settings: 'tnum' on, 'lnum' on;

  color: #5FC4B8;
}

.files-menu {
  text-align: left;
  background: #161618;
  padding: 17px;
}

.files-list {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;

  font-feature-settings: 'tnum' on, 'lnum' on;
}

.files-title {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  padding-top: 22px;

  color: #FFFFFF;
  height: 70px;
  text-transform: none;

  background: #25272B;
  border-radius: 5px 5px 0px 0px;
}

.dropdown-content {
  background: #161618;
}

.upload-file {
  font-size: 17px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;

  letter-spacing: 1px;
  text-transform: uppercase;

  color: #5FC4B8;
}

#dropdown-menu1 {
  min-width: 20rem;
}

.files-list {
  width: 100%;

  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  padding: 8px 12px;

  font-feature-settings: 'tnum' on, 'lnum' on;

  a {
    color: #FFFFFF;
    float: right;
  }
}

.files-list:hover {
  color: whitesmoke;
  background: rgba(91, 96, 103, 0.3);
  border-radius: 5px;
}

.font-size {
  text-transform: none;
}

.icon-align {
  vertical-align: text-top;
}

.id-box {
  height: calc(100% - 95px);
  position: relative;
}

.clear-link {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: 1px;
  text-transform: uppercase;
  font-feature-settings: 'tnum' on, 'lnum' on;

  color: #5FC4B8;
  z-index: 38;
}

.output-message {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 38;

  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  font-feature-settings: 'tnum' on, 'lnum' on;

  color: #98A4AE;
}

.modal-background {
  background: #25272B;
  opacity: 0.5;
}

.modal-content {
  padding: 24px 18px;
  width: 500px;
  height: 253px;
  background: #25272B;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5);
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  font-feature-settings: 'tnum' on, 'lnum' on;

  color: #FFFFFF;

  .confim-title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .confirm-buttons {
    margin-top: 25px;

    button {
      width: 153px;
    }
  }
}
</style>
